import type { ReadinessBand } from '@/lib/api/org';

export const BAND_META: Record<ReadinessBand, { label: string; badgeClass: string; dotClass: string }> = {
  product_ready: {
    label: 'Product-ready',
    badgeClass: 'bg-emerald-100 text-emerald-700',
    dotClass: 'bg-emerald-500',
  },
  service_ready: {
    label: 'Service-ready',
    badgeClass: 'bg-blue-100 text-blue-700',
    dotClass: 'bg-blue-500',
  },
  developing: {
    label: 'Developing',
    badgeClass: 'bg-amber-100 text-amber-700',
    dotClass: 'bg-amber-500',
  },
  needs_support: {
    label: 'Needs support',
    badgeClass: 'bg-red-100 text-red-700',
    dotClass: 'bg-red-500',
  },
};

export const BAND_ORDER: ReadinessBand[] = ['product_ready', 'service_ready', 'developing', 'needs_support'];
